import type { SVGProps } from "react";
export interface FootprintsIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function FootprintsIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: FootprintsIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="m20.125 15.208.115.006a1.125 1.125 0 0 1 0 2.238l-.115.006h-5.25a1.125 1.125 0 0 1 0-2.25zm-11-3 .116.006a1.125 1.125 0 0 1 0 2.239l-.116.005h-5.25a1.125 1.125 0 0 1 0-2.25z"
      />
      <path
        fill={color}
        d="M19.875 8.791c0-.838-.378-1.504-1.014-1.972-.655-.481-1.61-.76-2.695-.68-.369.026-.537.152-.646.285-.14.17-.264.46-.334.905-.145.915 0 1.983.08 2.761.068.675.24 1.669.412 2.838.164 1.12.322 2.37.322 3.405v2.834c0 1.025.751 1.707 1.5 1.707.75 0 1.5-.682 1.5-1.707v-2.834c0-1.046.236-2.675.45-4.114.228-1.535.425-2.83.425-3.428M2.75 16.166v-2.833c0-.841-.202-2.278-.425-3.785-.21-1.41-.45-2.943-.45-3.757 0-1.612.767-2.93 1.932-3.785C4.953 1.165 6.457.78 8 .894c.945.07 1.696.465 2.219 1.102.492.599.714 1.329.817 1.98.203 1.277.002 2.708-.063 3.343-.075.738-.268 1.865-.425 2.934-.164 1.12-.298 2.226-.298 3.08v2.833c0 2.104-1.6 3.959-3.75 3.959s-3.75-1.855-3.75-3.959m19.375-7.375c0 .814-.24 2.346-.45 3.757-.223 1.507-.425 2.944-.425 3.785v2.834c0 2.103-1.6 3.957-3.75 3.957s-3.75-1.854-3.75-3.957v-2.834c0-.854-.134-1.96-.298-3.08-.157-1.07-.35-2.196-.425-2.934-.065-.635-.265-2.066-.063-3.343.103-.651.325-1.381.817-1.98.523-.637 1.274-1.033 2.22-1.102 1.543-.113 3.046.27 4.192 1.112 1.165.856 1.932 2.173 1.932 3.785m-18-3c0 .599.197 1.893.425 3.428.214 1.439.45 3.068.45 4.115v2.832c0 1.026.75 1.708 1.5 1.709.749 0 1.5-.683 1.5-1.709v-2.832c0-1.035.158-2.287.322-3.406.171-1.17.344-2.163.413-2.838.08-.778.224-1.846.079-2.76-.07-.445-.194-.736-.334-.906-.11-.133-.277-.259-.646-.286-1.085-.08-2.04.2-2.695.681-.636.468-1.014 1.134-1.014 1.972"
      />
    </svg>
  );
}
